import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=31067d5d&"
import script from "./PublicFooter.vue?vue&type=script&lang=js&"
export * from "./PublicFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports